export default __webpack_public_path__ + "static/media/ElephantPage1.5f22a87e.txt";